<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.go(-1)" />

                <div class="header-block location-center">
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                    </div>
                    <div class="label">
                        {{ $t('paymentPage.payment') }}
                    </div>
                    <div class="barrier">
                        <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                    </div>
                </div>

                <div>
                    <div class="tariff-info mt-72">
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>

                            <div class="text-panel__background">

                            </div>

                            <div class="text-panel__text" style="color: #E0C522;">
                                {{ store.tariffObject.name }}
                            </div>

                        </div>
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>

                            <div class="text-panel__background">

                            </div>

                            <div class="text-panel__multi-text" style="color: #E0C522;">
                                <div v-if="store.tariffType === 'internet'">{{ store.tariffObject.id_down }}<span class="micro-text"> {{ $t('paymentPage.speed') }}</span></div>
                                <div v-if="store.tariffType === 'tv'">{{ store.tariffObject.channels.length }}<span class="micro-text"> {{ $t('paymentPage.channels') }}</span></div>
                                <div>{{ store.tariffObject.summa }}<span class="micro-text"> {{ $t('paymentPage.currency') }}/<span v-if="store.tariffObject.name !== 'Day'">{{ $t('paymentPage.priceMonth') }}</span><span v-else>{{ $t('paymentPage.priceDay') }}</span>
                                </span></div>
                            </div>

                        </div>
                    </div>

                    <div class="tariff-info">
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>

                            <div class="text-panel__background">

                            </div>

                            <div class="text-panel__multi-text">
                                <div style="color: #C7C8D1;"><span class="micro-text">{{ $t('paymentPage.averageBalance') }}</span></div>
                                <div style="color: #E0C522;">{{ store.balance.toFixed(2) }}<span class="micro-text"> {{ $t('paymentPage.currency') }}</span></div>
                            </div>

                        </div>
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>

                            <div class="text-panel__background">

                            </div>

                            <div class="text-panel__multi-text">
                                <div style="color: #C7C8D1;"><span class="micro-text">{{ $t('paymentPage.choosedPeriod') }}</span></div>
                                <div style="color: #E0C522;">{{ store.tariffPeriod }} <span class="micro-text" v-if="store.tariffObject.name !== 'Day'">{{ $t('paymentPage.priceMonth') }}</span><span class="micro-text" v-else>{{ $t('paymentPage.moreDays') }}</span></div>
                            </div>

                        </div>
                        <div class="text-panel">
                            <div class="text-panel__lt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="0.273566" y1="4.38855" x2="0.273566" y2="-2.14457e-05" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.547852" y1="0.27442" x2="4.38785" y2="0.27442" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__lb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.38855" y1="5.05749" x2="-2.14337e-05" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="0.274542" y1="4.7832" x2="0.274542" y2="0.943203" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rb-angle">
                                <svg width="5" height="6" viewBox="0 0 5 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="4.11413" y1="0.943481" x2="4.11413" y2="5.33205" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="3.83984" y1="5.05749" x2="-0.000156188" y2="5.05749" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>
                            <div class="text-panel__rt-angle">
                                <svg width="5" height="5" viewBox="0 0 5 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line y1="0.725714" x2="4.38857" y2="0.725714" stroke="#C7C8D1" stroke-width="0.548571"/>
                                    <line x1="4.11413" y1="1" x2="4.11413" y2="4.84" stroke="#C7C8D1" stroke-width="0.548571"/>
                                </svg>
                            </div>

                            <div class="text-panel__background">

                            </div>

                            <div class="text-panel__multi-text">
                                <div style="color: #C7C8D1; text-transform: lowercase;"><span class="micro-text">{{ $t('paymentPage.endOfTariff') }}</span></div>
                                <div style="color: #E0C522;">{{ paymentDetails?.date_end ? getDateStringByTimestamp(paymentDetails.date_end) : '' }}</div>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="price-block">
                    <div class="price-block__bill">
                        <div style="color: #C7C8D1; font-size: 12px;">
                            {{ $t('paymentPage.priceHeader') }}<br>{{ $t('paymentPage.choosedTariffHeader') }}
                        </div>
                        <div style="color: #E0C522; font-size: 22px;">
                            {{ paymentDetails?.total_summ }}<span class="micro-text"> {{ $t('paymentPage.currency') }}</span>
                        </div>
                    </div>
                    <div v-if="paymentDetails?.summ_day_dop" class="price-block__description">
                        <div>
                            доплата за Інтернет (неповний місяць)
                        </div>
                        <div>
                            ({{ paymentDetails?.days_diff_dop }}дн. х {{paymentDetails?.summ_day_dop}}грн = {{ paymentDetails?.summ_day_dop }}грн)
                        </div>
                    </div>
                    <div v-if="paymentDetails?.sum_dop" class="price-block__description">
                        <div>
                            доплата за перехід на більший тариф
                        </div>
                        <div>
                            ({{ paymentDetails?.days_diff }}дн. х {{paymentDetails?.summ_day}}грн = {{ paymentDetails?.sum_dop }}грн)
                        </div>
                    </div>
                </div>
            </div>

            <div class="adaptation-block__column desktop-mt-45">
                <div class="footer-wrapper" style="max-width: none;">
                    <div v-if="selectedOption != 0 && store.tariffObject.name != 'UA:Новини'" class="selected-tariff__footer">
                        <div class="settings-options_option" style="padding: 0 19px;">
                            <div class="settings-options_label">{{ $t('aboutMePage.cardAdded') }}</div>
                            <div class="settings-options_switch">
                                <uzhnet-switch v-model="autoWriteOffCard" />
                            </div>
                        </div>
                        <uzhnet-button-secondary v-if="store.balance >= store.tariffPeriod * store.tariffObject.summa" class="w-92" @click="createBalanceTransactionInternet" :label="$t('paymentPage.writeoffBalanceButton')" />

                        <div v-if="store.balance < store.tariffPeriod * store.tariffObject.summa" class="none-balance-container">
                            <div class="none-balance-label" style="margin-bottom: 5px;">{{ $t('paymentPage.notFundsOnBalance') }}</div>
                            <uzhnet-button-danger class="w-92 opacity-50" :label="$t('paymentPage.writeoffBalanceButton')" />
                        </div>
                        <uzhnet-button v-if="store.tariffType === 'internet'" class="w-92" @click="createTransaction" :label="$t('paymentPage.oneTimePayment')" />
                        <uzhnet-button v-if="store.tariffType === 'tv'" class="w-92" @click="createTransactionTv" :label="$t('paymentPage.oneTimePayment')" />
                    </div>
                    <div v-else class="selected-tariff__footer">
                        <uzhnet-button class="w-92" @click="createBalanceTransactionTv" :label="$t('paymentPage.addTariff')" />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useMainStore } from '@/store/mainStore'
import ApiManager from '@/services/ApiManager'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils';
import { getAccountByLogin, dropAllAccounts } from '@/db/accountService';
import { getDateStringByTimestamp } from '@/services/utils'

function formatDescriptionInHtml(inputHtml) {
    // Регулярний вираз для пошуку description
    const descriptionRegex = /"description":"(.*?)"/;

    // Знайти description у рядку
    const match = inputHtml.match(descriptionRegex);

    if (match && match[1]) {
        const encodedDescription = match[1];

        // Декодуємо текст із символами Unicode
        const decodedDescription = JSON.parse(`"${encodedDescription}"`);

        // Замінюємо старе значення на декодоване
        const updatedHtml = inputHtml.replace(
            descriptionRegex,
            `"description":"${decodedDescription}"`
        );

        return updatedHtml;
    } else {
        console.error("Description not found in the input HTML string.");
        return inputHtml; // Повертаємо початковий HTML, якщо description не знайдено
    }
}

export default {
    name: "PaymentPage",

    setup() {
        const store = useMainStore()
        const router = useRouter()

        const autoWriteOffCard = ref(false)

        const paymentDetails = ref(null)

        const calculateTransaction = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            const response = await ApiManager.getInternetPaymentDetails(auth_token, store.tariffObject.tid, store.tariffPeriod)

            return response.data
        }

        const createTransaction = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            const response = await ApiManager.payForInternet(auth_token, {
                tariff_id: store.tariffObject.tid,
                period: store.tariffPeriod,
                regular: autoWriteOffCard.value ? 1 : 0,
            })
            const formHtml = formatDescriptionInHtml(response.data.html_content)

            const action = formHtml.match(/action="([^"]*)/)[1] // get action from form
            const method = formHtml.match(/method="([^"]*)/)[1] // get method from form
            const id = formHtml.match(/id="([^"]*)/)[1] // get id from form

            const form = document.createElement('form')
            form.action = action
            form.method = method
            form.id = id
            form.innerHTML = formHtml
            document.body.appendChild(form)
            form.submit()

            router.push('/payment-success')
        }

        const createTransactionTv = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            const response = await ApiManager.payForTv(auth_token, {
                tariff_id: store.tariffObject.tid,
                period: store.tariffPeriod,
                regular: autoWriteOffCard.value ? 1 : 0,
            })
            const formHtml = formatDescriptionInHtml(response.data.html_content)

            const action = formHtml.match(/action="([^"]*)/)[1] // get action from form
            const method = formHtml.match(/method="([^"]*)/)[1] // get method from form
            const id = formHtml.match(/id="([^"]*)/)[1] // get id from form

            const form = document.createElement('form')
            form.action = action
            form.method = method
            form.id = id
            form.innerHTML = formHtml
            document.body.appendChild(form)
            form.submit()

            router.push('/payment-success')
        }

        const createBalanceTransactionTv = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            await ApiManager.payForTvBalance(auth_token, {
                tariff_id: store.tariffObject.tid,
                period: store.tariffPeriod
            })
            router.push('/payment-success')
        }

        const createBalanceTransactionInternet = async () => {
            const fingerprint = await calculateFingerprint()
            const maybeAccount = await getAccountByLogin(store.login)
            let auth_token = ''
            try {
                auth_token = await decryptMessage(maybeAccount.token, fingerprint, maybeAccount.iv)
            } catch (error) {
                console.error('Unable to decrypt saved account:', error.message);
                await dropAllAccounts()
                router.push('/')
                return
            }

            await ApiManager.payForInternetBalance(auth_token, {
                tariff_id: store.tariffObject.tid,
                period: store.tariffPeriod
            })
            router.push('/payment-success')
        }

        onMounted(async () => {
            paymentDetails.value = await calculateTransaction()
        })

        return {
            store,
            createTransaction,
            createTransactionTv,
            createBalanceTransactionTv,
            autoWriteOffCard,
            paymentDetails,
            getDateStringByTimestamp: getDateStringByTimestamp,
            createBalanceTransactionInternet
        }
    }
}
</script>

<style lang="scss">
    .mt-72 {
        margin-top: 72px;
    }

    .tariff-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .selected-tariff__footer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .none-balance-label {
        color: #D81159;
        font-size: 12px;
        text-align: center;
    }

    .none-balance-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
    }

    .opacity-50 {
        opacity: 0.5;
    }

    .price-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        width: 100%;
        padding: auto;
        margin-top: 100px;

        &__bill {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-around;
            align-items: center;
            margin-bottom: 20px;
        }

        &__description {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            font-size: 10px;
            color: #C7C8D1;
        }

    }

    .footer-wrapper {
        min-height: 700px;

        width: 100%;
        height: 100%;
        max-width: 480px;

        & > .selected-tariff__footer {
            bottom: 0;
        }

    }
</style>
